export var isDev = process.env.NODE_ENV === 'development';
export function sendErrorAtDev(error) {
  if (error && isDev) {
    if (error instanceof Error) {
      // eslint-disable-next-line no-console
      console.error(error);
      return;
    }
    // eslint-disable-next-line no-console
    console.error(new Error(error));
  }
}
export function setSvgAttr(cloneSvg, svgConfig) {
  cloneSvg.setAttribute('width', svgConfig.width || '1em');
  cloneSvg.setAttribute('height', svgConfig.height || '1em');
  cloneSvg.setAttribute('fill', svgConfig.fill || 'currentColor');
  if (svgConfig.spin) {
    cloneSvg.setAttribute('class', 'ab-icon-spin');
  }
  if (svgConfig.svgStyle) {
    for (var key in svgConfig.svgStyle) {
      if (Object.prototype.hasOwnProperty.call(svgConfig.svgStyle, key)) {
        cloneSvg.style[key] = svgConfig.svgStyle[key];
      }
    }
  }
  if (svgConfig.rotate) {
    cloneSvg.style.transform = "rotate(".concat(svgConfig.rotate, "deg)");
  }
}
/**
 * 判断属性是否相同
 */
export function propsDiff(a, b) {
  for (var i in a) {
    if (!(i in b)) {
      return true;
    }
  }
  for (var i in b) {
    if (a[i] !== b[i]) {
      return true;
    }
  }
  return false;
}